import { useEffect, useState } from 'react'
import { getPaymentAdapterLookup } from '../core/_requests'
import { ROLE, UserModel } from '../../modules/auth'
import { IsGranted } from '../../modules/auth/PrivateRoute'

/**
 * Staff who see every adapter must name the adapter for an operation-id search. Merchant-side roles
 * and pure cashiers are scoped by the backend and neither see nor send the adapter.
 */
export const isAdapterScopeRequired = (currentUser?: UserModel): boolean =>
  IsGranted(
    [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
    currentUser,
  )

export type AdapterSearch = { field?: string; query: string } | undefined

export type AdapterSelectOption = { label: string; value: string }

export const ADAPTER_ID_SEARCH_ERROR =
  'Выберите адаптер: ID операции уникален только внутри своего адаптера'

export const ADAPTER_FILTER_LABEL = 'Адаптер (для поиска по ID адаптера)'

/** The search targets the adapter's operation id, has text, and no adapter is chosen yet. */
export const isAdapterSearchBlocked = (
  required: boolean,
  search: AdapterSearch,
  adapterField: string,
  paymentAdapterId?: string | null,
): boolean => required && search?.field === adapterField && !!search.query?.trim() && !paymentAdapterId

/** `paymentAdapterId` travels only with a search by the adapter's operation id. */
export const adapterIdPayload = (
  required: boolean,
  search: AdapterSearch,
  adapterField: string,
  paymentAdapterId?: string | null,
): { paymentAdapterId?: number } =>
  required && search?.field === adapterField && search.query?.trim() && paymentAdapterId
    ? { paymentAdapterId: Number(paymentAdapterId) }
    : {}

/** Adapter options for the selector next to the "ID у адаптера" search. */
export const usePaymentAdapterOptions = (enabled = true): AdapterSelectOption[] => {
  const [options, setOptions] = useState<AdapterSelectOption[]>([])

  useEffect(() => {
    if (!enabled) return
    let alive = true
    getPaymentAdapterLookup()
      .then((res) => {
        if (!alive || !res?.data?.success) return
        setOptions((res.data.data ?? []).map((o) => ({ label: o.label, value: String(o.value) })))
      })
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [enabled])

  return options
}
